// Sprint 6-home-redesign: блок «Что изменилось» (top-3). ЕДИНСТВЕННОЕ место со
// стрелкой ↑↓ — это ДИНАМИКА (изменение с прошлого замера), цвет = delta_color.
// Ссылка «Все маркеры →» ведёт в «Маркеры» без фильтра (отдельного экрана
// изменений не строим).

import { MarkerRow } from '@/components/dashboard/MarkerRow';
import { limitChanges } from '@/lib/homeAttention';
import type { HeadlineChange } from '@/api/types';

// HEAL-75 изм. 3: ссылка «Все маркеры →» отсюда убрана. Она вела в тот же
// экран, что и «Все показатели» на Главной, — два названия у одного перехода.
// Строки блока по-прежнему открывают карточки показателей.
export function ChangesList({
  changes,
  onOpen,
}: {
  changes: HeadlineChange[];
  onOpen: (code: string) => void;
}) {
  if (changes.length === 0) return null;

  const shown = limitChanges(changes);

  return (
    <section className="px-4">
      <h2 className="mb-2 text-hl-section font-bold text-foreground">Что изменилось</h2>

      <div className="space-y-2">
        {shown.map((c) => (
          <MarkerRow
            key={c.biomarker_code}
            variant="change"
            name={c.canonical_name_ru}
            value={c.curr_value}
            prevValue={c.prev_value}
            unit={c.unit_normalized}
            delta={{
              delta_value: c.delta_value,
              delta_pct: c.delta_pct,
              delta_color: c.delta_color,
            }}
            onClick={() => onOpen(c.biomarker_code)}
          />
        ))}
      </div>

    </section>
  );
}
